<div class="wrapper">
  <div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-2 ps-2">
      <div class="container-fluid">
        <div class="default_class">
          <div class="content-wrapper p-0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xl-12">
                  <div class="card rounded shadow-lg">
                    <div class="card-header headerbg" style="border-bottom: 3px solid #d8eff8">
                      <h5 class="mb-0">Learners</h5>
                    </div>
                    <div class="card-body">
                      <div class="dd-container">
                        <div class="dd-wrapper">
                          <label class="lbl" for="sel1">Institutes</label>
                          <div class="saparator"><strong>:</strong> &nbsp;</div>
                          <select [(ngModel)]="tId" (change)="changeLearners($event.target.value)"
                            class="form-select shadow-sm rounded-lg dd" id="sel1">
                            <option value="" [selected]="true">Select</option>
                            <option *ngFor="let item of institutions" [value]="item.TNT_CODE">
                              {{ item.TNT_NAME }}
                            </option>
                          </select>
                        </div>
                        <div class="dd-wrapper">
                          <label class="lbl" for="sel1">Learners</label>
                          <div class="saparator"><strong>:</strong> &nbsp;</div>
                          <select class="form-select shadow-sm rounded-lg dd" id="sel1">
                            <option value="" [selected]="true">Select</option>
                            <option *ngFor="let item of roles" [value]="item.ROLE_ID">
                              {{ item.ROLE_NAME }}
                            </option>
                          </select>
                        </div>

                      </div>

                      <div *ngIf="table.length" class="table-responsive">
                        <table id="patreggraph" datatable class="table-striped table-bordered mt-2 pt-2 table-sm small"
                          style="width: 100%">
                          <thead class="top">
                            <tr>
                              <th>Institute Name</th>
                              <th>Maisha ID</th>
                              <th>Full Name</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of table">
                              <td>{{ item.REGISTRATION_NUMBER }}</td>
                              <td>{{ item.FIRSTNAME }} {{item.LASTNAME}}</td>
                              <td>{{ item.STATUS }}</td>
                              <td>
                                <button class="btn btn-save" data-bs-toggle="modal" data-bs-target="#applicationForm"
                                  (click)="viewApplicationForm(item)">
                                  View
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="text-center" *ngIf="!table.length">
                        No Records to display
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" data-backdrop="static" data-keyboard="false" id="applicationForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Learner Admissions Details</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" id="md_close" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div id="printtable" class="pt-5">
          <table width="980" cellspacing="0" cellpadding="0" style="margin: auto">
            <tbody>
              <tr>
                <td>
                  <table width="980" border="0" cellspacing="10" cellpadding="0">
                    <tbody>
                      <tr>
                        <td height="" style="text-align: end" valign="middle">
                          <img src="../../../../assets/img/bharat-logo.png" width="150" alt="" />
                        </td>
                        <td rowspan="4">
                          <div class="row">
                            <div class="col-xl-8"></div>
                            <div class="col-xl-4">
                              <div class="pt-2 d-flex" style="width: 125px; height: 125px">
                                <img [src]="videoUrl + userDetails?.result?.upload_4" class="img-fluid m-auto"
                                  style="margin: auto; max-height: 100%" alt="" />
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="text-align: center">&nbsp;</td>
                      </tr>
                      <!-- <tr>
                          <td style="text-align: center">
                            <table width="100%">
                              <tr>
                                <td width="35%">
                                  <p
                                    style="
                                      margin: 0px;
                                      font-size: 12px !important;
                                    "
                                  >
                                    <b>P.O. BOX</b> 2440-00606 LESSOS, KENYA
                                  </p>
                                </td>
                                <td width="35%">
                                  <p
                                    style="
                                      margin: 0px;
                                      font-size: 12px !important;
                                    "
                                  >
                                    <b>TELEPHONE:</b> 202395160/719792792
                                  </p>
                                </td>
                                <td width="30%">
                                  <p
                                    style="
                                      margin: 0px;
                                      font-size: 12px !important;
                                    "
                                  >
                                    <b>EMAIL:</b> info&#64;tonp.ac.ke
                                  </p>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: center">&nbsp;</td>
                        </tr> -->
                      <tr>
                        <td style="text-align: end">
                          <h4 style="
                                margin-top: 0;
                                margin-bottom: 10px;
                                font-weight: 600;
                              ">
                            Admissions Office
                          </h4>
                          <h5 style="color: #fe7f50; font-weight: 500">
                            Learner Summary Admissions Form
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td colspan="2" style="padding: 10px">
                  <!-- <table width="100%" border="0" cellspacing="0" cellpadding="6" style="font-size: 13px">
                      <tbody>
                        <tr>
                          <td colspan="6" style="
                              border-bottom: 1px dashed #333;
                              font-size: 13px;
                            ">
                            <h5><b>(A) PROGRAM SELECTION</b></h5>
                          </td>
                        </tr>
                        <tr>
                          <td><b>Institute Type</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td>
                            {{ userDetails?.result?.course_type_name }}
                          </td>
                          <td><b>Class</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td>{{ userDetails?.result?.course_name }}</td>
                        </tr>
  
                        <tr *ngIf="userDetails?.result?.is_cluster">
                          <td colspan="6">
                            <table class="table-bdr" width="100%" border="1" cellspacing="0" cellpadding="6">
                              <tbody>
                                <tr>
                                  <th>Class Cluster</th>
                                  <th>Subject Name(eg MAT)</th>
                                  <th>Grade obtained</th>
                                </tr>
                                <tr>
                                  <td>CLUSTER SUBJECT 1</td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT1_NAME
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT1_GRADE
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>CLUSTER SUBJECT 2</td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT2_NAME
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT2_GRADE
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>CLUSTER SUBJECT 3</td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT3_NAME
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT3_GRADE
                                    }}
                                  </td>
                                </tr>
                                <tr>
                                  <td>CLUSTER SUBJECT 4</td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT4_NAME
                                    }}
                                  </td>
                                  <td>
                                    {{
                                    userDetails?.get_cluster
                                    ?.CLUSTER_SUBJECT4_GRADE
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table> -->
                  <table width="100%" border="0" cellspacing="0" cellpadding="6"
                    style="border-top: 2px dashed #333; font-size: 13px">
                    <tbody>
                      <tr>
                        <td colspan="6" style="
                              border-bottom: 1px dashed #333;
                              font-size: 13px;
                            ">
                          <h5><b>(A) LEARNER DETAILS</b></h5>
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>First Name</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.firstname }}
                        </td>
                        <td width="24%"><b>Middle Name</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.middlename }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Last Name</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.lastname }}</td>
                        <td><b>Country of Residence</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>{{ userDetails?.result?.country_of_residence }}</td>
                      </tr>

                      <tr>
                        <td *ngIf="userDetails?.result?.counties_id != 0">
                          <b>County</b>
                        </td>
                        <td *ngIf="userDetails?.result?.counties_id != 0" width="2%" style="text-align: center">
                          :
                        </td>
                        <td *ngIf="userDetails?.result?.counties_id != 0">
                          {{ userDetails?.result?.counties_name }}
                        </td>

                        <td><b>Mobile Number</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{ userDetails?.result?.mobileno_code_name }}
                          {{ userDetails?.result?.mobileno }}
                        </td>
                        <!-- <td *ngIf="userDetails?.result?.counties_id !=0"><b>Sub County</b></td>
                                                <td *ngIf="userDetails?.result?.counties_id !=0" width="2%"
                                                    style="text-align: center;">:</td>
                                                <td *ngIf="userDetails?.result?.counties_id !=0">
                                                    {{userDetails?.result?.sub_counties_name}}</td> -->

                        <!-- <td><b>Postal Address</b></td>
                                                <td width="2%" style="text-align: center;">:</td>
                                                <td>{{userDetails?.result?.postal_address}} </td> -->
                      </tr>
                      <tr>
                        <!-- <td *ngIf="userDetails?.result?.counties_id !=0"><b>Constituency</b>
                                                </td>
                                                <td *ngIf="userDetails?.result?.counties_id !=0" width="2%"
                                                    style="text-align: center;">:</td>
                                                <td *ngIf="userDetails?.result?.counties_id !=0">
                                                    {{userDetails?.result?.con_counties_name}}</td> -->
                      </tr>
                      <!-- <tr>
                                                <td><b>Physical Address</b></td>
                                                <td width="2%" style="text-align: center;">:</td>
                                                <td>{{userDetails?.result?.physical_address}}</td>
                                                <td><b>Postal Code</b></td>
                                                <td width="2%" style="text-align: center;">:</td>
                                                <td>{{userDetails?.result?.postal_code}}</td>
                                            </tr> -->

                      <tr>
                        <!-- <td><b>Town/City</b></td>
                                                <td width="2%" style="text-align: center;">:</td>
                                                <td>{{userDetails?.result?.nearest_town}}</td> -->

                        <td width="24%"><b>Current Email</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.username }}</td>
                      </tr>

                      <tr>
                        <td colspan="6" style="
                              border-bottom: 1px dashed #333;
                              font-size: 13px;
                            ">
                          <h5><b>(B) Biographical Information</b></h5>
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Gender</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.gender_name }}
                        </td>
                        <td width="24%"><b>Date of Birth</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">{{ userDetails?.result?.dob }}</td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Birth Country</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.counties_name }}
                        </td>
                        <td width="24%"><b>Location Of Birth</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.birthlocation }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>County of Birth</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.counties_name }}
                        </td>
                        <td width="24%"><b>Sub County of Birth</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.sub_counties_name }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Orphan</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{
                          userDetails?.result?.orphan == 1
                          ? "YES"
                          : userDetails?.result?.orphan == 2
                          ? "NO"
                          : "Do Not Wish To Disclose"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%"><b>Disability</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td width="24%">
                          {{ userDetails?.result?.isdisability_name }}
                        </td>
                        <td width="24%" *ngIf="
                              userDetails?.result?.isdisability_name == 'YES'
                            ">
                          <b>Type Of Disability</b>
                        </td>
                        <td width="2%" *ngIf="
                              userDetails?.result?.isdisability_name == 'YES'
                            " style="text-align: center">
                          :
                        </td>
                        <td width="24%" *ngIf="
                              userDetails?.result?.isdisability_name == 'YES'
                            ">
                          {{ userDetails?.result?.typeofdisability_name }}
                        </td>
                      </tr>
                      <tr>
                        <td width="24%" *ngIf="
                              userDetails?.result?.isdisability_name == 'YES' &&
                              userDetails?.result?.typeofdisability_name ==
                                'OTHER'
                            ">
                          <b>Disability Description</b>
                        </td>
                        <td width="2%" *ngIf="
                              userDetails?.result?.isdisability_name == 'YES' &&
                              userDetails?.result?.typeofdisability_name ==
                                'OTHER'
                            " style="text-align: center">
                          :
                        </td>
                        <td width="24%" *ngIf="
                              userDetails?.result?.isdisability_name == 'YES' &&
                              userDetails?.result?.typeofdisability_name ==
                                'OTHER'
                            ">
                          {{ userDetails?.result?.disability_description }}
                        </td>
                        <td><b>Nationality</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>{{ userDetails?.result?.nan_code }}</td>
                      </tr>
                      <tr>
                        <td><b>Identification Document Type</b></td>
                        <td width="2%" style="text-align: center">:</td>
                        <td>
                          {{ userDetails?.result?.id_passport_type_name }}
                        </td>
                        <td>
                          <b>{{
                            userDetails?.result?.id_passport_type_name
                            }}</b>
                        </td>
                        <td width="2%" style="text-align: center">:</td>
                        <td colspan="4">
                          {{ userDetails?.result?.id_passport }}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table *ngIf="userDetails?.lst.length" width="100%" border="0" cellspacing="0" cellpadding="6"
                    style="border-bottom: 1px dashed #333; font-size: 13px">
                    <tbody>
                      <tr></tr>
                      <tr style="border-bottom: 0px dashed #333; font-size: 13px">
                        <td colspan="6">
                          <h5><b>(C) Previous Academic Details :</b></h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div *ngFor="let item of userDetails?.lst">
                    <table width="100%" border="1" cellspacing="0" cellpadding="6">
                      <tbody>
                        <tr>
                          <td width="24%"><b>School Attending</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.INSTITUTION_NAME }}</td>
                          <td width="24%"><b>Grade</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.GRADE }}</td>
                        </tr>
                        <tr>
                          <td width="24%">
                            <b>KNEC Assessment Number / KCPE Index Number</b>
                          </td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.EXAM_REG_NO }}</td>
                          <td width="24%"><b>SNE/TYPE</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.SNETYPE }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <ng-container *ngIf="
                        userDetails?.result?.name_of_emergency ||
                        userDetails?.result?.relationshipname_of_emergency_name ||
                        userDetails?.result?.mobile_no_emergency
                      ">
                    <table width="100%" border="0" cellspacing="0" cellpadding="6" style="font-size: 13px">
                      <tbody>
                        <tr>
                          <td colspan="6" style="
                                border-bottom: 1px dashed #333;
                                font-size: 13px;
                              ">
                            <h5>
                              <b>({{ userDetails?.lst.length ? "E" : "D" }})
                                Parent/Guardian Details :</b>
                            </h5>
                          </td>
                        </tr>
                        <tr>
                          <td><b>Full Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td>{{ userDetails?.result?.name_of_emergency }}</td>
                          <td><b>Relationship</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td>
                            {{
                            userDetails?.result
                            ?.relationshipname_of_emergency_name
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td><b>Telephone</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td>
                            {{
                            userDetails?.result?.emergency_mobileno_code_name
                            }}
                            {{ userDetails?.result?.mobile_no_emergency }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <!-- <table
                      width="100%"
                      border="0"
                      cellspacing="0"
                      cellpadding="6"
                      *ngIf="isRecommondations"
                    >
                      <tbody>
                        <tr
                          style="border-bottom: 1px dashed #333; font-size: 13px"
                        >
                          <td colspan="6">
                            <h5>
                              <b
                                >({{ isRecommondations == false ? "E" : "F" }})
                                RECOMMENDATIONS :</b
                              >
                            </h5>
                          </td>
                        </tr>
                      </tbody>
                    </table> -->
                  <!-- <div *ngFor="let item of userDetails?.lst_recommandations">
                      <table
                        width="100%"
                        border="1"
                        cellspacing="0"
                        cellpadding="6"
                        *ngIf="isRecommondations"
                      >
                        <tbody>
                          <tr>
                            <td width="24%"><b>Full Name</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">{{ item.NAME }}</td>
                            <td width="24%"><b>Organization</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">{{ item.ORGANIZATION }}</td>
                          </tr>
                          <tr>
                            <td width="24%"><b>Country</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">{{ item.COUNTRY_NAME }}</td>
                            <td width="24%"><b>Mobile Number</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">
                              {{ item.COUNTRY_CONNECTING_CODE }}
                              {{ item.MOBILE_NUMBER }}
                            </td>
                          </tr>
                          <tr>
                            <td width="24%"><b>City/Town</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">{{ item.CITY_TOWN }}</td>
                            <td width="24%"><b>Nationality</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">
                              {{ item.RECOMMENDATION_NATIONALITY }}
                            </td>
                          </tr>
                          <tr>
                            <td width="24%"><b>Recommender email</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%" colspan="4">
                              {{ item.EMAIL_ADDRESS }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div> -->

                  <!-- <table width="100%" border="0" cellspacing="0" cellpadding="6">
                      <tbody>
                        <tr style="border-bottom: 1px dashed #333; font-size: 13px">
                          <td colspan="6">
                            <h5>
                              <b>(F) REFERRAL :</b>
                            </h5>
                          </td>
                        </tr>
                        <tr>
                          <td width="24%"><b>Referred by</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ userDetails?.result?.ref_name }}</td>
                          <span *ngIf="userDetails?.result?.referral_platform_id == 8">
                            <td width="24%"><b>Description</b></td>
                            <td width="2%" style="text-align: center">:</td>
                            <td width="24%">
                              {{ userDetails?.result?.referral_name }}
                            </td>
                          </span>
                        </tr>
                      </tbody>
                    </table> -->
                </td>
              </tr>
              <tr>
                <td colspan="2" style="padding: 10px">
                  <table width="100%" border="0" cellspacing="0" cellpadding="6" style="font-size: 13px">
                    <tbody>
                      <tr>
                        <td colspan="6" style="
                              border-bottom: 1px dashed #333;
                              font-size: 13px;
                            ">
                          <h5>
                            <b>(C) Parent/Guardian Details :</b>
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngFor="let item of userDetails?.parentguardian">
                    <table width="100%" border="0" cellspacing="0" cellpadding="6">
                      <tbody>
                        <tr>
                          <td width="24%"><b>First Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.FIRSTNAME }}</td>
                          <td width="24%"><b>Middle Name</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.MIDDLENAME }}</td>
                        </tr>
                        <tr>
                          <td width="24%">
                            <b>Last Name</b>
                          </td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.LASTNAME }}</td>
                          <td width="24%"><b>Relationship</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item.PARENTTYPE_NAME }}
                          </td>
                        </tr>
                        <tr>
                          <td width="24%"><b>Type of ID</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.TYPE_OF_NAME }}</td>
                          <td width="24%">
                            <b> {{ item.TYPE_OF_NAME }} Id Number</b>
                          </td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.ID_NUMBER }}</td>
                        </tr>
                        <tr>
                          <td width="24%"><b>Country of Residence</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">{{ item.COUNTRY_NAME }}</td>
                          <td width="24%"><b>Mobile Number</b></td>
                          <td width="2%" style="text-align: center">:</td>
                          <td width="24%">
                            {{ item.COUNTRY_CONNECTING_CODE }}
                            {{ item.MOBILENO }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>

            </tbody>
          </table>
          <div class="footer float-end pt-2">
            <button id="Closemodal" class="btn btn-danger" data-bs-dismiss="modal">
              Close</button>&nbsp;&nbsp;
            <button class="btn btn-save" (click)="downloadForm()">
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>